/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './outlet-ref/outlet-ref.directive';
export * from './outlet-ref/outlet-ref.module';
export * from './outlet-renderer.service';
export * from './outlet.directive';
export * from './outlet.model';
export { OutletModule } from './outlet.module';
export { provideOutlet, ProvideOutletOptions } from './outlet.providers';
export * from './outlet.service';
